var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dropdown-product-images form-row mb-1" }, [
    _vm.isFileImage && !_vm.isFieldsTab
      ? _c("div", { staticClass: "col-3 d-flex align-items-center" }, [
          _vm._v("\n    Product\n  "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isFileImage && !_vm.isFieldsTab,
            expression: "isFileImage && !isFieldsTab",
          },
        ],
        staticClass: "col-9",
      },
      [
        _c("div", { staticClass: "input-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.productIds,
                expression: "productIds",
              },
            ],
            staticClass: "form-control product-ids-input",
            attrs: { type: "text", disabled: _vm.disabled, readonly: "" },
            domProps: { value: _vm.productIds },
            on: {
              focus: _vm.onFocusProductIds,
              input: function ($event) {
                if ($event.target.composing) return
                _vm.productIds = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "input-group-append" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-outline px-2",
                attrs: { disabled: _vm.disabled },
                on: {
                  click: function ($event) {
                    return _vm.onFocusProductIds(!_vm.isShowDropdown)
                  },
                },
              },
              [
                _c("i", {
                  class: {
                    "cil-chevron-bottom": !_vm.isShowDropdown,
                    "cil-chevron-top": _vm.isShowDropdown,
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.hover.topleft",
                    modifiers: { hover: true, topleft: true },
                  },
                ],
                staticClass: "btn btn-outline px-2",
                attrs: {
                  title: "Replace Product Images",
                  disabled: _vm.disabled,
                },
                on: {
                  click: function ($event) {
                    return _vm.openReplaceMode(!_vm.isShowDropdown)
                  },
                },
              },
              [_c("i", { staticClass: "bi bi-repeat" })]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.hover.topleft",
                    modifiers: { hover: true, topleft: true },
                  },
                ],
                staticClass: "btn btn-outline px-2",
                attrs: {
                  title: "Clear and Add New Product Images",
                  disabled: _vm.disabled,
                },
                on: {
                  click: function ($event) {
                    return _vm.openReplaceAllMode(!_vm.isShowDropdown, true)
                  },
                },
              },
              [_c("i", { staticClass: "bi bi-arrow-left-right" })]
            ),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowDropdown,
            expression: "isShowDropdown",
          },
        ],
        staticClass: "products-container",
        class: _vm.isContracted ? "products-container--contracted" : "",
      },
      [
        _c("div", { staticClass: "contract-btn-wrapper" }, [
          _c(
            "div",
            {
              staticClass: "contract-btn",
              on: {
                click: function ($event) {
                  _vm.isContracted = !_vm.isContracted
                },
              },
            },
            [
              !_vm.isContracted
                ? _c("b-icon", { attrs: { icon: "arrows-angle-contract" } })
                : _c("b-icon", { attrs: { icon: "arrows-angle-expand" } }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "close-btn" },
            [
              _c("b-icon", {
                attrs: { icon: "x-lg" },
                on: { click: _vm.handleClosePopup },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "file-browser-wrapper" },
          [_c("FileBrowser")],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttons-wrapper" },
          [
            _vm.isFileImage
              ? _c("span", { staticClass: "mr-auto" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.selectedCount) +
                      " Selected\n      "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-button",
              {
                on: {
                  click: function ($event) {
                    _vm.isShowDropdown = false
                  },
                },
              },
              [_vm._v("\n        Close\n      ")]
            ),
            _vm._v(" "),
            _vm.showReplaceAll
              ? _c(
                  "b-button",
                  {
                    attrs: { variant: "primary" },
                    on: { click: _vm.handleReplaceAll },
                  },
                  [_vm._v("\n        Replace\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showReplaceAll
              ? _c(
                  "b-button",
                  {
                    attrs: { variant: "primary" },
                    on: { click: _vm.handleReplaceAllApplyTo },
                  },
                  [_vm._v("\n        Replace in All Templates\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.fieldsReplaceAll
              ? _c(
                  "b-button",
                  {
                    attrs: { variant: "success" },
                    on: { click: _vm.handleImagesSave },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.isFileImage ? _vm.saveImageText : "Select") +
                        "\n      "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.pickedItems?.length &&
            _vm.pickedItems?.length > 1 &&
            _vm.mode === _vm.MODES.REPLACE
              ? _c(
                  "b-button",
                  {
                    attrs: { variant: "success" },
                    on: { click: _vm.handleReplaceAllProductImages },
                  },
                  [_vm._v("\n        Replace All\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.pickedItems?.length && _vm.mode === _vm.MODES.REPLACE
              ? _c(
                  "b-dropdown",
                  {
                    staticClass: "replace-options-dropdown",
                    attrs: {
                      split: "",
                      dropup: "",
                      text: "Replace Multiple",
                      variant: "success",
                    },
                    on: { click: _vm.handleImageReplacement },
                  },
                  [
                    _c(
                      "b-list-group",
                      [
                        _c(
                          "b-list-group-item",
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                                model: {
                                  value: _vm.replaceAllProducts,
                                  callback: function ($$v) {
                                    _vm.replaceAllProducts = $$v
                                  },
                                  expression: "replaceAllProducts",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Replace All Product Images\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-list-group-item",
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                                model: {
                                  value: _vm.replaceOnlyVisible,
                                  callback: function ($$v) {
                                    _vm.replaceOnlyVisible = $$v
                                  },
                                  expression: "replaceOnlyVisible",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Replace Visible Product Images\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-list-group-item",
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                                model: {
                                  value: _vm.applyToAllPreviews,
                                  callback: function ($$v) {
                                    _vm.applyToAllPreviews = $$v
                                  },
                                  expression: "applyToAllPreviews",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Apply to All Templates\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isFileImage && !_vm.isFieldsTab,
            expression: "isFileImage && !isFieldsTab",
          },
        ],
        staticClass: "col-12 my-2",
      },
      [
        _c("ProductImageUploads", {
          on: { replaceImages: _vm.replaceProductIds },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }